module.exports = __webpack_public_path__ + "static/Forsidu-loopa-4-5ec413407e80be207fe0d6751e02754d.mp4";